import { render, staticRenderFns } from "./IotComponent.vue?vue&type=template&id=5f47bb55"
import script from "./IotComponent.vue?vue&type=script&lang=js"
export * from "./IotComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports